import agentIcon1 from "../assets/images/agent_icon3.svg";
import agentIcon2 from "../assets/images/agent_icon2.svg";
import agentIcon3 from "../assets/images/agent_icon1.svg";
import agentIcon4 from "../assets/images/agent_icon4.svg";
import agentIcon5 from "../assets/images/agent_icon5.svg";
import agentIcon6 from "../assets/images/agent_icon6.svg";
import agentIcon7 from "../assets/images/agent_icon7.svg";
import agentIconDefault from "../assets/images/agent_icon_default.svg"

// Category-specific icon mapping
export const CATEGORY_ICON_MAP: Record<string, string> = {
  "CEO's Office": agentIcon1,
  Marketing: agentIcon2,
  "Augmented Human capital": agentIcon3,
  Procurement: agentIcon4,
  "Legal and Compliance": agentIcon5,
  Finance: agentIcon6,
  HR: agentIcon7,
  // Commercial: agentIcon4,
};

// Default fallback icon
export const DEFAULT_AGENT_ICON = agentIconDefault;

/**
 * Get the icon for a specific category
 * @param category - The agent category
 * @param customIcon - Optional custom icon to override category icon
 * @returns The icon source path
 */
export const getCategoryIcon = (
  category?: string | null,
  customIcon?: string
): string => {
  if (customIcon) return customIcon;
  if (!category) return DEFAULT_AGENT_ICON;
  return CATEGORY_ICON_MAP[category] || DEFAULT_AGENT_ICON;
};
